export const formatNumberWithSpaces = (
  value: number | null | undefined,
): string => {
  if (value === null || value === undefined) return '';
  const stringValue = String(value);
  const [intPart, decPart] = stringValue.split('.');
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  if (decPart === undefined) {
    return formattedInt;
  }

  const limitedDecPart = decPart.slice(0, 4);

  if (!limitedDecPart) {
    return formattedInt;
  }

  return `${formattedInt},${limitedDecPart}`;
};
